import { useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import api from '../../../utils/api';
import { GET_MATRIC_FORMAT_QUERY_KEY, MatricFormat } from './useCreateMatricFormatMutation';

export interface MatricFormatResponse {
  statusCode: number;
  message: string;
  data: MatricFormat;
}

export const useGetMatricFormatQuery = () => {
  const fetchMatricFormat: () => Promise<MatricFormatResponse> = async () => {
    return (await api.get('/MatricFormat/get'))?.data;
  };

  const { data, isLoading, isError, error, refetch } = useQuery<MatricFormatResponse, AxiosError<ApiErrorResponse>>({
    queryKey: GET_MATRIC_FORMAT_QUERY_KEY,
    queryFn: fetchMatricFormat,
  });

  const errorMessage = error?.response?.data?.message || error?.message || 'Failed to fetch matric format';

  return {
    data,
    matricFormatData: data?.data,
    matricFormatSegments: data?.data?.segments ?? [],
    isLoading,
    isMatricFormatLoading: isLoading,
    isError,
    isMatricFormatError: isError,
    errorMessage,
    matricFormatErrorMessage: errorMessage,
    refetch,
  };
};
